module.exports = __webpack_public_path__ + "img/holy-see.10a95488.svg";